import React from "react";
import "./experience.css";
import { BsPatchCheckFill } from "react-icons/bs";

const Experience = () => {
    return (
        <section id="experience">
            <h5>Les compétences que je maitrise</h5>
            <h2>Mon Experience</h2>

            <div className="container experience__container">
                <div className="experience__frontend">
                    <h3>Frontend Developement</h3>
                    <div className="experience__content">
                        <article className="experience__details">
                            <BsPatchCheckFill className="experience-details-icon" />
                            <div>
                                <h4>HTML</h4>
                                <small className="text-light">
                                    Expérimenté
                                </small>
                            </div>
                        </article>
                        <article className="experience__details">
                            <BsPatchCheckFill className="experience-details-icon" />
                            <div>
                                <h4>CSS</h4>
                                <small className="text-light">
                                    Intermédiaire
                                </small>
                            </div>
                        </article>
                        <article className="experience__details">
                            <BsPatchCheckFill className="experience-details-icon" />
                            <div>
                                <h4>JavaScript</h4>
                                <small className="text-light">
                                    Intermédiaire
                                </small>
                            </div>
                        </article>
                        <article className="experience__details">
                            <BsPatchCheckFill className="experience-details-icon" />
                            <div>
                                <h4>WordPress</h4>
                                <small className="text-light">
                                    Intermédiaire
                                </small>
                            </div>
                        </article>
                        <article className="experience__details">
                            <BsPatchCheckFill className="experience-details-icon" />
                            <div>
                                <h4>React</h4>
                                <small className="text-light">
                                    Intermédiaire
                                </small>
                            </div>
                        </article>
                        <article className="experience__details">
                            <BsPatchCheckFill className="experience-details-icon" />
                            <div>
                                <h4>Three JS</h4>
                                <small className="text-light">Débutant</small>
                            </div>
                        </article>
                    </div>
                </div>
                {/* Fin de frond end */}
                <div className="experience__backend">
                    <h3>Backend Developement</h3>
                    <div className="experience__content">
                        <article className="experience__details">
                            <BsPatchCheckFill className="experience-details-icon" />
                            <div>
                                <h4>PHP</h4>
                                <small className="text-light">
                                    Intermédiaire
                                </small>
                            </div>
                        </article>
                        <article className="experience__details">
                            <BsPatchCheckFill className="experience-details-icon" />
                            <div>
                                <h4>MYSQL</h4>
                                <small className="text-light">
                                    Intermédiaire
                                </small>
                            </div>
                        </article>
                        <article className="experience__details">
                            <BsPatchCheckFill className="experience-details-icon" />
                            <div>
                                <h4>Express JS</h4>
                                <small className="text-light">
                                    Intermédiaire
                                </small>
                            </div>
                        </article>
                        <article className="experience__details">
                            <BsPatchCheckFill className="experience-details-icon" />
                            <div>
                                <h4>PYTHON</h4>
                                <small className="text-light">
                                    Intermédiaire
                                </small>
                            </div>
                        </article>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Experience;
